// verticalPref.ts
export type VerticalId = "care" | "rentals" | "wallet" | "booking";
const K = "lastVertical";
const K_EXP = "lastVerticalExp";

// 🔔 notify listeners in this tab about changes (storage doesn't fire for same-tab)
function notifyVerticalChanged() {
  try {
    window.dispatchEvent(new Event("vertical:changed"));
  } catch {}
}

export function saveVerticalPref(v: VerticalId, days = 30) {
  localStorage.setItem(K, v);
  localStorage.setItem(K_EXP, String(Date.now() + days * 864e5));
  notifyVerticalChanged();
}

export function saveVerticalSession(v: VerticalId) {
  sessionStorage.setItem(K, v);
  notifyVerticalChanged();
}

/**
 * Returns the raw stored vertical (session has priority) or null.
 * Does NOT handle expiry.
 */
export function getStoredVertical(): string | null {
  return sessionStorage.getItem(K) ?? localStorage.getItem(K);
}

export function setStoredVertical(v: any) {
  localStorage.setItem(K, v);
  notifyVerticalChanged();
}

/**
 * ✅ Preferred: returns an effective VerticalId considering:
 * - sessionStorage override
 * - localStorage value
 * - local expiry (K_EXP)
 * - fallback to "care"
 */
export function getActiveVertical(): VerticalId {
  const sessionV = sessionStorage.getItem(K) as VerticalId | null;
  if (sessionV) return sessionV;

  const exp = Number(localStorage.getItem(K_EXP) || 0);
  if (exp && Date.now() > exp) {
    localStorage.removeItem(K);
    localStorage.removeItem(K_EXP);
    return "care";
  }

  const localV = localStorage.getItem(K) as VerticalId | null;
  return (localV ?? "care");
}

/** Map a VerticalId to its UI label */
export function getVerticalLabel(v: VerticalId): string {
  switch (v) {
    case "booking":
      return "Booking";
    case "wallet":
      return "Coin";      // per your requirement
    case "rentals":
      return "Rentals";
    case "care":
    default:
      return "Care";
  }
}
